var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "otpModal",
      attrs: {
        title: "Código de verificación",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        centered: ""
      }
    },
    [
      _c("div", { staticClass: "text-center mb-4" }, [
        _c("p", [
          _vm._v(
            "Se ha enviado un código de verificación a su correo electrónico."
          )
        ]),
        _c("p", { staticClass: "text-muted" }, [
          _vm._v("Ingrese el código para completar la firma.")
        ])
      ]),
      _c("b-overlay", { attrs: { show: _vm.loading } }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("otp-input", {
                attrs: { disabled: _vm.loading },
                on: { complete: _vm.submitOtp },
                model: {
                  value: _vm.otpCode,
                  callback: function($$v) {
                    _vm.otpCode = $$v
                  },
                  expression: "otpCode"
                }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "text-center mt-4" },
          [
            _c(
              "b-button",
              {
                attrs: {
                  variant: "success",
                  disabled: _vm.otpCode.length < 6 || _vm.loading
                },
                on: { click: _vm.submitOtp }
              },
              [_vm._v(" Confirmar firma ")]
            ),
            _c(
              "b-button",
              {
                staticClass: "ml-2",
                attrs: { variant: "outline-secondary", disabled: _vm.loading },
                on: { click: _vm.cancel }
              },
              [_vm._v(" Cancelar ")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }